<template>
  <el-scrollbar>
  <label style="margin-left: 5px;font-weight: bold">基础信息:</label>
  <el-card style="margin: 5px">
    <el-form :model="securityTempData" label-width="200px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="配置名称:" required>
            <el-input v-model="securityTempData.name" placeholder="配置名称" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="社保地区:" required>
            <el-select v-model="securityTempData.area_id" placeholder="社保地区" clearable>
              <el-option v-for="item in socialSecurityAreaList" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="序号:" required>
            <el-input-number :min="0" v-model="securityTempData.sort_no" placeholder="序号" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="缴费基数:" required>
            <el-input-number :min="0" v-model="securityTempData.base_pay" step="1000" placeholder="缴费基数" clearable />
          </el-form-item>
        </el-col>
      </el-row>
<!--      <el-row>-->
<!--        <el-col :span="12">-->
<!--          <el-form-item label="最低缴费基数:" required>-->
<!--            <el-input-number :min="0" v-model="securityTempData.minimum_base_pay" step="1000" placeholder="最低缴费基数" clearable />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--      </el-row>-->
    </el-form>
  </el-card>
  <label style="margin-left: 5px;font-weight: bold">社保信息:</label>
  <el-card style="margin: 5px">
    <el-form :model="securityTempData" label-width="200px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="基本养老保险-公司(%):" required>
            <el-input v-model="securityTempData.old_age_insurance_company" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="基本养老保险-个人(%):" required>
            <el-input v-model="securityTempData.old_age_insurance_employee" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="失业保险-公司(%):" required>
            <el-input v-model="securityTempData.unemployment_insurance_company" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="失业保险-个人(%):" required>
            <el-input v-model="securityTempData.unemployment_insurance_employee" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工伤保险-公司(%):" required>
            <el-input v-model="securityTempData.injury_insurance_company" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <label style="margin-left: 5px;font-weight: bold">医疗信息:</label>
  <el-card style="margin: 5px">
    <el-form :model="securityTempData" label-width="200px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="基本医疗保险-公司(%):" required>
            <el-input v-model="securityTempData.medical_insurance_company" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="基本医疗保险-个人(%):" required>
            <el-input v-model="securityTempData.medical_insurance_employee" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="地方附加医疗保险-公司(%):" required>
            <el-input v-model="securityTempData.supplementary_medical_company" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="大额医疗费用补助-个人(元):" required>
            <el-input v-model="securityTempData.large_medical_employee" oninput="value=value.replace(/[^\d]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="生育保险-公司(%):" required>
            <el-input v-model="securityTempData.maternity_insurance_company" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="请填写数字" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
    <div style="text-align: center;margin-bottom: 20px;margin-top: 10px">
      <el-button style="width: 100px" type="primary" :loading="loading" @click="saveSecurityTemp">保存</el-button>
    </div>
  </el-scrollbar>
</template>

<script>

export default {
  name: "SocialSecurityTemplate",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'type',
        label: 'name'
      },
      loading: false,
      securityTempData: {},
      socialSecurityAreaList: [],
    }
  },
  methods: {
    async loadSecurityTempInfo() {
      let params = {id: this.parentData.id}
      let dbTemp = await this.$http('salaryInfoSetService.getTempById', params);
      if(dbTemp){
        this.securityTempData = dbTemp;
      }
    },
    //获取社保缴纳地
    async getSocialSecurityArea() {
      this.socialSecurityAreaList = await this.$http('salaryInfoSetService.getAllArea');
    },
    saveSecurityTemp(){
      if(!this.securityTempData.name){
        return this.$message.error("配置名称不能为空")
      }
      if(!this.securityTempData.area_id){
        return this.$message.error("社保地区不能为空")
      }
      if(this.securityTempData.base_pay ==null){
        return this.$message.error("缴费基数不能为空")
      }
      // if(!this.securityTempData.minimum_base_pay){
      //   return this.$message.error("最低缴费基数不能为空")
      // }
      let oldAgeInsuranceCompany = Number(this.securityTempData.old_age_insurance_company);
      if(Number.isNaN(oldAgeInsuranceCompany) || oldAgeInsuranceCompany >=100 || oldAgeInsuranceCompany <0){
        return this.$message.error("基本养老保险-公司的范围需在0-100之间")
      }
      let oldAgeInsuranceEmployee = Number(this.securityTempData.old_age_insurance_employee);
      if(Number.isNaN(oldAgeInsuranceEmployee) || oldAgeInsuranceEmployee >=100 || oldAgeInsuranceEmployee <0){
        return this.$message.error("基本养老保险-公司的范围需在0-100之间")
      }
      let medicalInsuranceCompany = Number(this.securityTempData.medical_insurance_company);
      if(Number.isNaN(medicalInsuranceCompany) || medicalInsuranceCompany >=100 || medicalInsuranceCompany <0){
        return this.$message.error("基本医疗保险-公司的范围需在0-100之间")
      }
      let medicalInsuranceEmployee = Number(this.securityTempData.medical_insurance_employee);
      if(Number.isNaN(medicalInsuranceEmployee) || medicalInsuranceEmployee >=100 || medicalInsuranceEmployee <0){
        return this.$message.error("基本医疗保险-个人的范围需在0-100之间")
      }
      let unemploymentInsuranceCompany = Number(this.securityTempData.unemployment_insurance_company);
      if(Number.isNaN(unemploymentInsuranceCompany) || unemploymentInsuranceCompany >=100 || unemploymentInsuranceCompany <0){
        return this.$message.error("失业保险-公司的范围需在0-100之间")
      }
      let unemploymentInsuranceEmployee = Number(this.securityTempData.unemployment_insurance_employee);
      if(Number.isNaN(unemploymentInsuranceEmployee) || unemploymentInsuranceEmployee >=100 || unemploymentInsuranceEmployee <0){
        return this.$message.error("失业保险-个人的范围需在0-100之间")
      }
      let  injuryInsuranceCompany = Number(this.securityTempData.injury_insurance_company);
      if(Number.isNaN(injuryInsuranceCompany) || injuryInsuranceCompany >=100 || injuryInsuranceCompany <0){
        return this.$message.error("工伤保险-公司的范围需在0-100之间")
      }
      let  maternityInsuranceCompany = Number(this.securityTempData.maternity_insurance_company);
      if(Number.isNaN(maternityInsuranceCompany) ||maternityInsuranceCompany >=100 || maternityInsuranceCompany <0){
        return this.$message.error("生育保险-公司的范围需在0-100之间")
      }
      // let  housingFundCompany = Number(this.securityTempData.housing_fund_company);
      // if(Number.isNaN(housingFundCompany) || housingFundCompany >=100 || housingFundCompany <0){
      //   return this.$message.error("住房公积金-公司的范围需在0-100之间")
      // }
      // let  housingFundEmployee = Number(this.securityTempData.housing_fund_employee);
      // if(Number.isNaN(housingFundEmployee) || housingFundEmployee>=100 || housingFundEmployee <0){
      //   return this.$message.error("住房公积金-个人的范围需在0-100之间")
      // }
      let supplementaryMedicalCompany = Number(this.securityTempData.supplementary_medical_company);
      if(Number.isNaN(supplementaryMedicalCompany) || supplementaryMedicalCompany >=100 || supplementaryMedicalCompany <0){
        return this.$message.error("补充医疗保险-公司的范围需在0-100之间")
      }
      this.loading = true;
      this.$http('salaryInfoSetService.saveSecurityTemp', this.securityTempData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
  },
  created() {
    this.getSocialSecurityArea();
    this.loadSecurityTempInfo();
  },

}
</script>

<style scoped lang="less">

</style>